import { Text, TextProps } from "@mantine/core"

export type ClickableTextProps = {
  onClick: () => void
  text: string
} & TextProps

export const ClickableText: React.FC<ClickableTextProps> = ({
  onClick,
  text,
  ...props
}: ClickableTextProps) => {
  return (
    <Text
      onClick={onClick}
      variant="tertiary"
      c="var(--mantine-color-dimmed)"
      td="underline"
      ta="right"
      style={{ cursor: "pointer" }}
      {...props}
    >
      {text}
    </Text>
  )
}
